// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

$w.onReady(function () {
  $w("#vectorImage28").onClick(() => {
    $w('#statebox9').changeState("state3");
  } );
  $w("#vectorImage29").onClick(() => {
    $w('#statebox9').changeState("State1");n
  } );
});